import { getNumTitles } from '@App/helpers/pagination/get-num-titles'
import { PaginationBody } from '@Entities/pagination'

export const findPageOnLimitChange = (
    pagination: PaginationBody,
    workCount = 0,
    newLimit: number,
    defaultPage = 0,
    isBebopApi = false
): number => {
    const currentPage = pagination.page ?? defaultPage
    const numTitles = getNumTitles(workCount, currentPage, pagination.limit ?? 10)
    return Math.ceil(Math.max(numTitles.firstTitle / newLimit, isBebopApi ? 0 : 1))
}
